<template>
  <div class="cols">
    <Stack
      v-for="(group, groupIndex) in columns"
      :key="group.priority"
      class="col"
      gap="4"
      :data-priority="group.priority"
    >
      <div>
        <PriorityBadge :priority="group.priority" />
      </div>

      <draggable
        v-model="columns[groupIndex].tasks"
        :group="{ name: 'tasks', pull: true, put: true }"
        handle=".task-grip"
        @end="onDragEnd"
      >
        <TaskElement
          v-for="element in columns[groupIndex].tasks"
          :key="element.uuid"
          :task="element"
          variant="kanban"
        />
      </draggable>
    </Stack>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import { Stack } from '@stakeui'; // adjust if needed
import TaskElement from './TaskElement.vue';
import PriorityBadge from '@frontend/ui/features/tasks/components/priority/PriorityBadge.vue';

export default {
  name: 'KanbanBoard',
  components: {
    Stack,
    draggable,
    TaskElement,
    PriorityBadge,
  },
  props: {
    tasks: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      // clone the prop to allow local mutations
      columns: JSON.parse(JSON.stringify(this.tasks)),
    };
  },
  methods: {
    onDragEnd(event) {
      const fromCol = event.from.closest('[data-priority]')?.getAttribute('data-priority');
      const toCol = event.to.closest('[data-priority]')?.getAttribute('data-priority');
      const { oldIndex, newIndex } = event;

      console.log(`Moved from ${fromCol}[${oldIndex}] → ${toCol}[${newIndex}]`);

      // Optional: emit to parent
      this.$emit('task-moved', { fromCol, toCol, oldIndex, newIndex });
    },
  },
};
</script>

<style scoped>
.cols {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1em;
  align-items: stretch;
}
</style>
